import { startListening } from '@bonanza-social/toolkit/state';
import { updateMarketingPreferences } from '@bonanza-social/account';
import { removeMarketingMessages } from '@bonanza-social/inbox';

startListening({
  actionCreator: updateMarketingPreferences.fulfilled,
  effect: (action, { dispatch }) => {
    const { allowInboxMarketingTool } = action.meta.arg;
     if (!allowInboxMarketingTool ) {
      dispatch(removeMarketingMessages());
     }
  },
});